import { OiaRiscoBanner } from "./oia-risco-banner";

const OIA_RISCO_URL = "https://pidigital.pi.gov.br/app/app-oiaorisco";

export const OiaRiscoBannerContainer = () => {
  return <OiaRiscoBanner url={OIA_RISCO_URL} />;
};
